import axios from 'axios'
import { Axios } from 'utils/AxiosConfig'

export const postXenditPayment = async (payload) => {
  const { data: response } = await axios.post(`https://api.xendit.co/callback_virtual_accounts/external_id=${payload.ref_id}/simulate_payment`,
    payload.body, {
    auth: {
      username: window.REACT_APP_XENDIT_USERNAME,
      password: ''
    }}
  )
  return response
}

// Buat Xendit Components session — backend harus call Xendit Sessions API
// dengan mode: "COMPONENTS" dan return { components_sdk_key: "..." }
export const postCreateCreditCardSession = async (payload) => {
  const { data: response } = await Axios.post('/payment/sessions/credit-card', payload)
  return response
}